import * as clack from '@clack/prompts'
import type { UpdateCommandOptions } from '@cli-types/core-engine/commands.js'
export function validateShadcnPresetOptions(
  components: string[],
  options: UpdateCommandOptions
): void {
  if (options.only && !options.shadcnPreset) {
    clack.cancel('--only can only be used with --shadcn-preset.')
    process.exit(1)
  }

  if (!options.shadcnPreset) {
    return
  }

  if (options.list) {
    clack.cancel('--list cannot be combined with --shadcn-preset.')
    process.exit(1)
  }

  if (options.all) {
    clack.cancel('--all cannot be combined with --shadcn-preset.')
    process.exit(1)
  }

  if (components.length > 0) {
    clack.cancel('Component names cannot be combined with --shadcn-preset.')
    process.exit(1)
  }
}
